import { useState, useSyncExternalStore } from "react";

import { t } from "../../i18n";
import {
  INSTALL_NUDGE,
  markDismissed,
  wasDismissed,
} from "../../lib/dismissal";
import {
  getInstallState,
  promptInstall,
  subscribeInstall,
} from "../../lib/install";
import { isTouchDevice } from "../../lib/platform";

/**
 * Asks people to put the app on their home screen.
 *
 * It exists because nothing else does the asking. iOS never offers to install a
 * web app, Android's own prompt appears on its own schedule and often not at
 * all, and notifications on iPhone do not work until the app is installed — so
 * without this the feature is real but undiscoverable.
 *
 * Phones and tablets only. Desktop Chrome can install too, but desktop
 * notifications work from an ordinary tab, so there is nothing to gain.
 */
export function InstallBanner() {
  const state = useSyncExternalStore(subscribeInstall, getInstallState);
  const [dismissed, setDismissed] = useState(() => wasDismissed(INSTALL_NUDGE));

  if (dismissed || !isTouchDevice()) return null;
  if (state !== "promptable" && state !== "ios-manual") return null;

  function dismiss() {
    markDismissed(INSTALL_NUDGE);
    setDismissed(true);
  }

  return (
    <div className="updatebar" role="status">
      {state === "promptable" ? (
        <>
          <span>{t("Install Roof Board on this device.")}</span>
          <button className="btn-primary" onClick={() => void promptInstall()}>
            {t("Install")}
          </button>
        </>
      ) : (
        // iOS cannot be prompted, only instructed.
        <span>
          {t(
            "To install: tap Share, then “Add to Home Screen”. Notifications need this.",
          )}
        </span>
      )}
      <button className="btn-ghost" onClick={dismiss}>
        {t("Not now")}
      </button>
    </div>
  );
}
